import React from 'react';
import { Divider, makeStyles } from '@material-ui/core';
import DepartmentTabs from './DepartmentTabs';
import SearchContainer from './SearchContainer';

const useStyles = makeStyles({
  divider: {
    marginTop: '20px',
  },
});

const MainContainer = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [searchVal, setSearchVal] = React.useState('');
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <SearchContainer tabValue={value} setSearchVal={setSearchVal} setOpen={setOpen} open={open} />
      <Divider className={classes.divider} />
      <DepartmentTabs value={value} setValue={setValue} searchVal={searchVal} setOpen={setOpen} open={open} />
    </>
  );
};

export default MainContainer;
